<template>
  <v-app-bar
    app
    flat
    color="accent"
  >
    <v-btn
      color="primary"
      icon
      @click="$emit('drawer', true)"
    >
      <v-icon v-text="icons.revo" />
    </v-btn>
    <v-fade-transition>
      <v-btn
        v-show="shouldSynchronize"
        icon
        small
        @click="syncAll()"
      >
        <h-sync-icon />
      </v-btn>
    </v-fade-transition>
    <v-spacer />
    <v-btn-toggle
      :value="$store.state.dashboard.view"
      mandatory
      dense
      group
      color="primary"
      @change="$store.commit('dashboard/view', $event)"
    >
      <v-btn>
        <v-icon v-text="icons.viewList" />
      </v-btn>
      <v-btn>
        <v-icon v-text="icons.viewRooms" />
      </v-btn>
    </v-btn-toggle>
    <v-menu
      v-if="! $page.props.auth.demo"
      bottom
      min-width="200px"
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          v-on="on"
          v-bind="attrs"
        >
          <v-icon v-text="icons.account" />
        </v-btn>
      </template>
      <v-card color="accent">
        <v-list-item-content class="justify-center">
          <div class="mx-auto text-center">
            <h-avatar
              v-if="user.photo"
              :resource="user"
              size="62"
            />
            <h3 class="mt-2 mb-1">{{ user.name }}</h3>
            <p class="text-caption">{{ $store.getters['user/role'] }}</p>
            <v-divider class="my-3" />
            <v-btn
              icon
              x-large
              @click="$store.commit('user/lock')"
            >
              <v-icon large v-text="icons.lockScreen" />
            </v-btn>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
  import Synchronizable from '@/Mixins/Synchronizable'
  import Userable from '@/Mixins/Userable'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HAvatar from '@/Components/Avatar'
  import HSyncIcon from './SyncIcon'

  export default {
    mixins: [
      Synchronizable,
      Userable,
      UsesIcons,
    ],

    components: {
      HAvatar,
      HSyncIcon,
    },
  }
</script>
